module.exports = __webpack_public_path__ + "static/media/picture-(79).41a2bc56.JPG";